import React, { useContext, useEffect } from 'react';
import easyScroll from 'easy-scroll';
import { ScrollPosition } from '../../store';
import Website from '../Website';
import { Wrapper, List, Perspective, Scroll, TimelineWrapper } from './style';
import Timeline from '../Timeline';

const WebsiteIndex = ({ activeSlug, isActive, isInactive, websites }) => {
  const { scrollEl } = useContext(ScrollPosition.State);
  const scrollPositionDispatch = useContext(ScrollPosition.Dispatch);

  const handleScroll = evt => {
    const progress =
      evt.target.scrollTop /
      (evt.target.scrollHeight - evt.target.getBoundingClientRect().height);

    scrollPositionDispatch({
      type: 'setScrollProgress',
      scrollProgress: progress
    });
  };

  return (
    <Wrapper isActive={isActive} isInactive={isInactive}>
      <TimelineWrapper>
        <Timeline />
      </TimelineWrapper>
      <Perspective
        onScroll={handleScroll}
        ref={el => {
          if (!el || scrollEl) return;
          scrollPositionDispatch({ type: 'setScrollEl', scrollEl: el });
        }}
      >
        <Scroll
        >
          <List>
            {websites
              ? websites.map(website => (
                  <Website
                    key={website.id}
                    website={website}
                    isActive={activeSlug === website.slug}
                    isInactive={
                      activeSlug.length > 0 && activeSlug !== website.slug
                    }
                  />
                ))
              : null}
          </List>
        </Scroll>
      </Perspective>
    </Wrapper>
  );
};

export default WebsiteIndex;
